'use client';
import { ComponentType } from 'react';
import { PlaceholderConfig } from '@spa/lib/react/context/PlaceholderContext';
import { Props } from './checkout-footer.component';
import dynamic from 'next/dynamic';

const DynamicCheckoutFooterComponent: ComponentType<Props> = dynamic(
  () => import('./checkout-footer.component')
);

export default DynamicCheckoutFooterComponent;

export function calculateCheckoutFooterPlaceholderConfig(): PlaceholderConfig {
  const heightSinceWidth = [
    { sinceWidth: 0, height: 162 },
    { sinceWidth: 425, height: 102 },
    { sinceWidth: 768, height: 132 },
    { sinceWidth: 1024, height: 114 }
  ];

  return {
    heightSinceWidth
  };
}
